import React, { Component } from 'react';
import Mac from './../images/mac.jpg';
import { TimelineMax, Power1, CSSPlugin } from "gsap/all";
import aboutMe from './AboutMe';



const plugins = [CSSPlugin];

class About extends Component {
  constructor(props) {
    super(props);
    this.timeline = new TimelineMax({ paused: true });
    this.headerDivs = [];
    this.contentDivs = [];
    // const sortedAboutMe = [].concat(this.AboutMe)
    //   .sort((a, b) => a - b);
    // const sortObjectKeys = obj => Object.keys(this.AboutMe) // sorting keys 
    //   .sort() // putting it back to object 
    //   .reduce((acc, key) => {
    //     acc[key] = obj[key];
    //     return acc
    //   }, {})
    // console.log(sortObjectKeys);
    this.state = {
      aboutMe: aboutMe,
      // aboutMe: sortedAboutMe[0],
      // aboutMe: sortedAboutMe[0],
      tab_code: ".."
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.timeline
      .staggerFrom(this.headerDivs, 0.4, {
        autoAlpha: 0,
        // stagger: 0.1,
        //x: 25,
        delay: 0.25,
        ease: Power1.easeInOut
      }, 0.2)
      .staggerFrom(this.contentDivs, 0.4, {
        autoAlpha: 0,
        // stagger: 0.1,
        x: 25,
        ease: Power1.easeInOut
      }, 0.2);

    this.timeline.play();
  }
  render() {
    const props = this.props;
    let html_code = "";
    let tab_code = this.state.tab_code;
    // console.log(this.state.aboutMe);
    let full_html = "";
    this.state.aboutMe.map((line_no, i) => (
      // console.log(line_no[i], i),
      Object.keys(line_no).map((line_no_key, j) => (
        html_code = "",
        // console.log(line_no_key, line_no[line_no_key]),
        line_no[line_no_key].map((code, k) => {
          if (code.hasOwnProperty("tab_space") && code["tab_space"] != 0) {
            let tab_html = "";
            tab_html += "<div class='dots'>";
            for (let t = 0; t < code["tab_space"]; t++) {
              tab_html += tab_code;
            }
            tab_html += "</div>";
            html_code += `${tab_html}`;
          }
          html_code += `<${code["tag"]} class="${code["classname"]}">${code["html"]}</${code["tag"]}>`;
          // html_code += `<div className="${code["classname"]}">${code["html"]}</div>`;
        }),
        full_html += `<div key=${j} data-line-no=${line_no_key} class="code-line">${html_code}</div>`
      ))
    ));
    return (
      <div className="view-page-container about-page">
        <div className="container">
          <h2 className="text-center main-header" ref={div => (this.headerDivs[1] = div)}>Profile</h2>
          <div className="lead text-center" ref={div => (this.headerDivs[2] = div)}>I'm a creative UI Web developer</div>
          <hr />
          <div className="mb-4">
            {/* <Typing speed={50}> */}
            <div className="code-container" dangerouslySetInnerHTML={{ __html: full_html }} ref={div => (this.contentDivs[0] = div)} />
            {/* </Typing> */}
          </div>
          <div className="row">
            <div className="col-md-4" ref={div => (this.contentDivs[1] = div)}>
              <h3>About me</h3>
              <p>I am a Versatile Front-end Developer with experience in developing and managing complex e-commerce sites and internal frameworks. Excellent communication &amp; knowledge of computer. Eager to learn, ample will power &amp; concentration ability. As the saying goes: 'two heads are better than one'.
              </p>
            </div>
            <div className="col-md-4 text-center" ref={div => (this.contentDivs[2] = div)}>
              <img src={Mac} alt="Mackral" width="246" height="246" className="img-fluid rounded-circle" />
            </div>
            <div className="col-md-4" ref={div => (this.contentDivs[3] = div)}>
              <h3>Details</h3>
              <p>
                <strong>Name:</strong><br />
                Mackral Maxi Gonsalves<br />
                <strong>Age:</strong><br />
                29 years<br />
                <strong>Location:</strong><br />
                Mumbai, India, Earth
              </p>
            </div>
          </div>
        </div>
      </div >
    );
  }
}
export default About;
